import React from 'react';
import TrashIcon from '@images/trash.svg';
import Select, { ActionMeta, components } from 'react-select';

export interface CustomOption {
  label: string;
  value: number | string;
}

interface Props {
  value: CustomOption;
  onChange: (newValue: CustomOption, actionMeta: ActionMeta<CustomOption>) => void;
  options: CustomOption[];
  haveDelete?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
}

export default function CustomSelect({
  value,
  onChange,
  options,
  haveDelete = false,
  isLoading = false,
  isDisabled = false,
}: Props) {
  const { Option } = components;

  return (
    <Select
      className="react-select-container"
      classNamePrefix="react-select"
      value={value}
      onChange={onChange}
      isLoading={isLoading}
      options={options}
      isDisabled={isDisabled || isLoading}
      components={{
        Option: props => (
          <Option {...props}>
            {haveDelete && props.data.value === '0' ? <TrashIcon /> : props.data.label}
          </Option>
        ),
      }}
    />
  );
}
